import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { session, loadingSessionComplete } = useContext(AuthContext);
  const location = useLocation();

  // Need to make sure that the context has attempted to load the session
  if (!loadingSessionComplete) {
    return;
  }
  // If the user is trying to access a page, then redirect to that url after
  // they sign in
  const currentHost = window.location.host;
  const redirectParam =
    location.pathname === "/login" ? null : `${location.pathname}`;

  // Redirect to login if not signed in, preserving the redirect parameter if present

  if (!session) {
    const loginPath = `/login${
      redirectParam ? `?redirect=${redirectParam}` : ""
    }`;
    return (
      <Navigate to={loginPath} replace state={{ from: location.pathname }} />
    );
  }

  // If signed in, render the child components
  return children;
};

export default ProtectedRoute;
